import { UIText3 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

type TChatRemovalDateProps = {
  date: string;
};

export const ChatRemovalDate: React.VFC<TChatRemovalDateProps> = ({ date }) => {
  return (
    <div className={styles['container']} data-testid="chat_removal_date">
      <UIText3 color="black_60">Объявление снято с публикации</UIText3>
      <UIText3 color="black_60">{`в ${date}`}</UIText3>
    </div>
  );
};
